import {Action} from "../../../actions/actions";
import {SpecialPrizesPresetsActionTypes} from "../actions/actionTypes";
import {Subsidiary} from "../../halls/types/subsidiaries";

export function subsidiariesList(state: Subsidiary[] = [], action: Action) {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES_SUCCESS:
            return action.payload.subsidiaries.results;
        default:
            return state;
    }
}

export function subsidiariesLoading(state: boolean = false, action: Action): boolean {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES:
            return true;
        case SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES_SUCCESS:
        case SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES_FAIL:
            return false;
        default:
            return state;
    }
}
